import { selectDictionary } from 'features/dictionaries/dictionariesSelectors';

import { useAppSelector } from 'hooks/useTypedRedux';

import { Education as EducationType } from 'types/commons';

import { Dictionaries } from 'constants/enums';
import { MAX_SIDEBAR_EDUCATION_ITEMS_TO_SHOW } from 'constants/uiSettings';

import styles from './Education.module.scss';
import EducationItem from './EducationItem/EducationItem';

interface EducationProps {
  education: EducationType;
}

const Education = ({ education }: EducationProps) => {
  const educationDictionary = useAppSelector(
    selectDictionary(Dictionaries.Education)
  );
  const studyDictionary = useAppSelector(selectDictionary(Dictionaries.Study));
  const recordsToShow =
    education?.records?.slice(0, MAX_SIDEBAR_EDUCATION_ITEMS_TO_SHOW) || [];
  const recordsToShowWithMappedLabels = recordsToShow.map((el) => ({
    ...el,
    degree:
      (educationDictionary.find((item) => item.value === el.degree)
        ?.label as string) || el.degree,
    fieldOfStudy:
      (studyDictionary.find((item) => item.value === el.fieldOfStudy)
        ?.label as string) || el.fieldOfStudy
  }));

  return (
    <div className={styles.educationsListWrapper}>
      {recordsToShowWithMappedLabels.map((record, index) => (
        <EducationItem key={`education-${index}`} record={record} />
      ))}
    </div>
  );
};

export default Education;
